import React, { useEffect, useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Buttons from "../../../components/Controls/Buttons/Button";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from "../../../components/ProgressBar";
import ImageMapper from "react-img-mapper";
import {
  clearTableSelectionApiStatus,
  submitSelections,
} from "../../../redux/processor/actions";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";
import "./preMapData.scss";
// import LazyLoad from "react-lazyload";

const TabelSelections = React.forwardRef(
  (
    {
      imageData,
      selectionType,
      imageMapperWidth,
      imageMapperHeight,
      onClicked,
      pageRotateAngle,
      onSubmitCrop,
      ...props
    },
    ref,
    // ref2
  ) => {
    const defaultCropArea = {
      unit: "px", // Can be 'px' or '%'
      x: 116,
      y: 44,
      width: 58,
      height: 13,
    };

    const dispatch = useDispatch();
    const tableSelectionApiStatus = useSelector(
      (state) => state?.pro?.tableSelectionApiStatus
    );
    let extractedTableData = useSelector(
      (state) => state?.pro?.extractedTableData
    );

    const [crop, setCrop] = useState(null);
    const [selectedArea, setSelectedArea] = useState({});
    const [showSubmitButton, setShowSubmitButton] = useState(false);

    const [showCropScreen, setShowCropScreen] = useState(true);
    const [imageLoadedInDiv, setImageLoadedInDiv] = useState(false);
    // on negation showing image mapper

    const onChangePdforPageWhenTableSelectin = () => {
      setShowCropScreen(true);
      setCrop(defaultCropArea);
    };

    // Assign the child function to the ref
    React.useImperativeHandle(ref, () => ({
      onChangePdforPageWhenTableSelectin,
    }));
    // Assign the child function to the ref
    // React.useImperativeHandle(ref2, () => ({
    //   onChangePdforPageWhenTableSelectin,
    // }));

    // const refreshSelection = () => {
    //   if (selectionType === "table") {
    //     setCrop({
    //       unit: "px", // Can be 'px' or '%'
    //       x: 116,
    //       y: 44,
    //       width: 58,
    //       height: 13,
    //     });
    //     setShowSubmitButton(false);
    //   } else if (selectionType === "page") {
    //     const selectedAreaForFullPage = {
    //       // used only for submit button position ow for entire page selection need only extract_table_only flag
    //       unit: "px", // Can be 'px' or '%'
    //       x: 5,
    //       y: 5,
    //       height: imageMapperHeight - 10,
    //       width: imageMapperWidth - 10,
    //     };

    //     setCrop(selectedAreaForFullPage);
    //     setSelectedArea({
    //       ...selectedAreaForFullPage,
    //     });
    //     setShowSubmitButton(true);
    //   }
    //   setShowCropScreen(true);
    // };

    // React.useImperativeHandle(props?.ref2, () => ({
    //   refreshSelection,
    // }));

    useEffect(() => {
      if (selectionType === "table") {
        setCrop({
          unit: "px", // Can be 'px' or '%'
          x: 116,
          y: 44,
          width: 58,
          height: 13,
        });
        setShowSubmitButton(false);
      } else if (selectionType === "page") {
        const selectedAreaForFullPage = {
          // used only for submit button position ow for entire page selection need only extract_table_only flag
          unit: "px", // Can be 'px' or '%'
          x: 5,
          y: 5,
          height: imageMapperHeight - 10,
          width: imageMapperWidth - 10,
        };

        setCrop(selectedAreaForFullPage);
        setSelectedArea({
          ...selectedAreaForFullPage,
        });
        setShowSubmitButton(true);
      }
      setShowCropScreen(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectionType]);

    useEffect(() => {
      dispatch(clearTableSelectionApiStatus());
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (tableSelectionApiStatus?.apiSuccess === true) {
        setShowCropScreen(false);
      }
    }, [tableSelectionApiStatus]);

    const onChangeCrop = (c, p) => {
      setCrop(c);
      if (showSubmitButton) {
        if (c.height === 0 && c.width === 0) {
          setShowSubmitButton(false);
        }
      }
    };

    const onCropCompleted = (c) => {
      if (c.height && c.width) {
        setSelectedArea(c);
      }
    };

    const handleSubmit = () => {
      if (selectionType === "page") {
        dispatch(
          submitSelections({
            name: imageData?.name,
            pageNo: imageData?.pageNo,
            imageUrl: imageData?.imageUrl,
            extract_table_only: selectionType === "page" ? false : true,
            pageRotateAngle: pageRotateAngle,
            ...(selectionType === "table" && {
              coords: [
                selectedArea?.x,
                selectedArea?.y,
                selectedArea?.width,
                selectedArea?.height,
              ],
            }),
          })
        );
      } else onSubmitCrop({ selectedArea });
    };

    const clicked = (area, index, e) => {
      const dataToUpdate = extractedTableData;
      dataToUpdate[index] = {
        ...extractedTableData[index],
        preFillColor: "#ff00002e",
        fillColor: "#ff00002e",
      };
      extractedTableData = dataToUpdate;
      onClicked(area, index, e);
    };
    const handleImageLoad = () => {
      setImageLoadedInDiv(true);
    };

    // Calculate the position of the submit button
    const calculateButtonPosition = () => {
      const buttonPosition = {
        top: selectionType === "page" ? 10 : crop?.y + crop?.height + 10, // Adjust as needed
        left: crop?.x + crop?.width - 40, // Center horizontally
      };

      return buttonPosition;
    };

    // Calculate the position of the submit button
    const buttonPosition = calculateButtonPosition();

    return (
      <>
        {showCropScreen ? (
          <div className="p-relative">
            <div
              id="container"
              style={{
                transform: `rotate(${pageRotateAngle}deg)`,
                transition: "transform 150ms ease", // smooth transition
                cursor: "grab",
                left: [
                  90, 270, 450, 630, 810, 990, 1170, 1350, 1530, 1710, 1890,
                ].includes(pageRotateAngle)
                  ? "14%"
                  : 0,
                position: "relative",
              }}
            >
              <ReactCrop
                crop={crop}
                onChange={(c) => onChangeCrop(c)}
                onComplete={(c, p) => onCropCompleted(c, p)}
                maxWidth={imageMapperWidth}
                maxHeight={imageMapperHeight}
                disabled={selectionType === "page" ? true : false}
                onDragStart={() => setShowSubmitButton(false)}
                onDragEnd={() => setShowSubmitButton(true)}
              >
                <img src={imageData?.imageUrl} alt="TableImage" />
              </ReactCrop>
            </div>
            {showSubmitButton && crop?.width > 0 && crop.height > 0 && (
              <Buttons
                size="small"
                onClick={() => handleSubmit()}
                text="Submit"
                variant="contained"
                style={{
                  position: "absolute",
                  top: buttonPosition?.top,
                  left: buttonPosition?.left,
                  transform: "translate(-50%, -50%)", // Center the button
                }}
              />
            )}

            {tableSelectionApiStatus?.loading && <ProgressBar />}
          </div>
        ) : (
          <div
            id="container"
            style={{
              transform: `rotate(${pageRotateAngle}deg)`,
              transition: "transform 150ms ease", // smooth transition
              cursor: "grab",
              left: [
                90, 270, 450, 630, 810, 990, 1170, 1350, 1530, 1710, 1890,
              ].includes(pageRotateAngle)
                ? "14%"
                : 0,
              position: "relative",
            }}
          >
            <>
              <img
                alt="Map_Image"
                src={imageData.imageUrl}
                onLoad={() => handleImageLoad()}
                className="d-none"
              />
              {imageLoadedInDiv ? ( // this logoc is added due to very initial time bounding box is not appearing
                // <LazyLoad height={200} offset={100}>
                <ImageMapper
                  src={imageData.imageUrl}
                  map={{
                    name: imageData?.name,
                    areas: [...extractedTableData],
                  }}
                  width={imageMapperWidth}
                  height={imageMapperHeight}
                  onClick={(area, index, e) => clicked(area, index, e)}
                  imgWidth={imageMapperWidth}
                  natural={true}
                  responsive={true}
                  parentWidth={imageMapperWidth}
                />
              ) : (
                // </LazyLoad>
                <Box className="premap-loader-container">
                  <CircularProgress />
                  <span className="premap-loader-style">Loading...</span>
                </Box>
              )}
            </>
          </div>
        )}
        {tableSelectionApiStatus?.apiSuccess === true && (
          <CustomizedSnackbars
            severity="success"
            state={tableSelectionApiStatus?.apiSuccess}
            text={tableSelectionApiStatus?.message}
            handleClose={() => {
              dispatch(clearTableSelectionApiStatus());
            }}
          />
        )}
        {tableSelectionApiStatus?.apiError === true && (
          <CustomizedSnackbars
            severity="success"
            state={tableSelectionApiStatus?.apiError}
            text={tableSelectionApiStatus?.message}
            handleClose={() => {
              dispatch(clearTableSelectionApiStatus());
            }}
          />
        )}
      </>
    );
  }
);
export default TabelSelections;
